<template>
  <el-container class="add-dialog component-add-dialog">
    <header>
      <span>组件管理</span>
      <i class="iconfont icon-close" @click="dialogClose"></i>
    </header>
    <div class="content">
      <div class="banner">
        <div class="h1">组件管理</div>
        <div class="h2">每一个组件都代表牛X的诞生</div>
      </div>
      <div class="form">
        <div class="form-header">基本信息</div>
        <div class="form-content">
          <div class="form-item single">
            <span class="item-title"><span class="need">*</span>名称</span>
            <div class="item-right">
              <el-input v-model="componentName" placeholder="请输入名称" size="medium" :maxlength="25"></el-input>
            </div>
            <div class="err" v-if="err_cn"><i class="el-icon-warning"></i>{{err_cn}}</div>
          </div>
          <div class="form-item single">
            <span class="item-title"><span class="need">*</span>状态</span>
            <div class="item-right">
              <el-select v-model="status" placeholder="请选择(必填)" :disabled="component.cm_default === '1' || !!component.id">
                <el-option v-for="item in option" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="err" v-if="err_s"><i class="el-icon-warning"></i>{{err_s}}</div>
          </div>
          <div class="form-item single">
            <span class="item-title">备注</span>
            <div class="item-right">
              <el-input type="textarea" v-model="remark" placeholder="请输入" size="medium" :rows="3" resize="none" :maxlength="500"></el-input>
            </div>
          </div>
        </div>

        <div class="func">
          <div class="head">功能</div>
          <feature-list :featureData="featureData"></feature-list>
        </div>
      </div>
    </div>
    <footer>
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="dialogSave">保 存</el-button>
    </footer>
  </el-container>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import featureList from '@/common/components/feature-list'// 功能清单
// import tool from '@/common/js/tool.js'
import mixin from '@/common/js/mixins.js'
export default {
  props: ['component'],
  data () {
    return {
      response: this.component,
      addType: '',
      option: [{'label': '禁用', 'id': '0'}, {'label': '启用', 'id': '1'}],
      featureData: [],
      componentName: '',
      status: '1',
      remark: '',
      err_cn: '',
      err_s: ''
    }
  },
  mixins: [mixin],
  components: {
    featureList
  },
  mounted () {
    this.userList = []
    this.featureInit()
    console.log('response', this.component)
    if (this.component.id) {
      this.componentName = this.component.cm_name
      this.status = this.component.cm_state
      this.remark = this.component.cm_describe
    }
    // 功能清单-实时
    this.$bus.on('feature-edit', (value) => {
      if (value) {
        this.feature = value
      }
    })
  },
  methods: {
    featureInit () {
      HTTPServer.getAllComponentList({}, 'Loading').then((res) => {
        let arr = [{'funcList': res.basic_component, 'moduleName': '基础字段', 'type': 'basic_component'}, {'funcList': res.high_component, 'moduleName': '高级类组件', 'type': 'high_component'}]
        let componentAuth = {'basic_component': '', 'high_component': ''}
        if (this.component.component_auth) {
          let basic = this.component.component_auth.basic_component
          let high = this.component.component_auth.high_component
          componentAuth.basic_component = basic ? basic.split(',') : []
          componentAuth.high_component = high ? high.split(',') : []
        }
        arr.map((item) => {
          item.funcList.map((fun) => {
            delete fun.field
            delete fun.isDrag
            delete fun.icon
            fun.name = fun.label
            fun.id = fun.type
            fun.type = item.type
            fun.choice = componentAuth[item.type].includes(fun.id) ? '1' : '0'
          })
        })
        this.featureData = {data: arr, type: 2}
        console.log(this.featureData)
      })
    },
    /** 保存 */
    dialogSave () {
      var b = this.dataTraversal()
      if (b) {
        let componentAuth = {}
        this.feature.map((item) => {
          componentAuth[item.type] = []
          item.funcList.map((fun) => {
            if (fun.checked) {
              componentAuth[item.type].push(fun.id)
            }
          })
          componentAuth[item.type] = componentAuth[item.type].toString()
        })
        var jsondata = {'cm_name': this.componentName, 'cm_state': this.status, 'cm_describe': this.remark, 'component_auth': componentAuth}
        console.log(jsondata)
        if (this.component.id) {
          jsondata.id = this.component.id
          console.log(jsondata)
          HTTPServer.updateComponentManage(jsondata, 'Loading').then((res) => {
            this.$message({
              showClose: true,
              message: '保存成功！',
              type: 'success'
            })
            this.$bus.emit('closeAddModal', true)
            this.$bus.emit('query-component-detail', true)
            this.$bus.emit('query-component-list', true)
          })
        } else {
          HTTPServer.saveComponentManage(jsondata, 'Loading').then((res) => {
            this.$message({
              showClose: true,
              message: '保存成功！',
              type: 'success'
            })
            this.$bus.emit('closeAddModal', true)
            this.$bus.emit('query-component-list', true)
          })
        }
      }
    },
    /** 数据遍历 */
    dataTraversal () {
      this.err_cn = ''
      this.err_s = ''
      if (!this.componentName) {
        this.err_cn = '名称不能为空'
        return false
      }
      if (!this.status) {
        this.err_s = '状态不能为空'
        return false
      }
      return true
    },
    /** 关闭窗 */
    dialogClose () {
      this.$bus.emit('closeAddModal', true)
    }
  }
}
</script>

<style scoped lang="scss">
.component-add-dialog{
  .func{
    .head{
      border-bottom: 1px dashed #D9D9D9;
      font-size: 16px;
      color: #666666;
      height: 40px;
      line-height: 40px;
      margin-bottom: 10px;
    }
  }
  .feature-container{
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    overflow: hidden;
    height: auto;
    padding: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/business/component-add.vue